import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export default function Header(handle, {
    activeClass,
}) {
    gsap.registerPlugin(ScrollTrigger);

    const trigger = document.getElementsByTagName('main')[0].firstElementChild;

    function handleHeader() {
        ScrollTrigger.create({
            trigger: trigger,
            start: 'main',
            endTrigger: 'body',
            //end: 'bottom top',
            toggleClass: {
                targets: 'html',
                className: activeClass,
            },
        });
    }

    handleHeader();
}
